import * as Yup from 'yup'

export const timeSchema = Yup.string().matches(/^([01]?\d|2[0-3]):[0-5]\d$/, {
  excludeEmptyString: true,
})
